
import { computed } from 'vue'
import PreviewPairData from '@/components/block/PreviewPairData.vue'
import Button from '@/components/elements/Button.vue'

export default {
  name: 'UserInformation',

  components: {
    PreviewPairData,
    Button
  },

  props: {
    name: {
      type: String,
      require: true
    },
    label: {
      type: String,
      require: true
    },
    content: {
      type: String,
      default: ''
    }
  },

  setup(props: any) {
    const showBtn = computed(() => {
      if (props.name === 'hpcr_regist_status' && props.content) return false
      if (props.name === 'doctor_regist_flg' && props.content) return false
      if (props.name === 'line' && props.content) return false
      return true
    })

    return {
      showBtn
    }
  }
}
